import {
  Box,
  ButtonIcon,
  DropdownMenu,
  DropdownMenuItem,
  FontAwesomeIcon,
  ListItem,
} from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";

interface FilterCardProps {
  label: string;
  value: string;
  onEdit: () => void;
  onRemove: () => void;
}

export function FilterCard({ label, value, onEdit, onRemove }: FilterCardProps) {
  const { t } = useTranslation();

  return (
    <Box className="group flex min-h-16 items-center rounded-xs bg-light p-3 shadow-sm">
      <ListItem
        behavior="card"
        className="w-full"
        title={label}
        caption={value}
        valueSlot={
          <DropdownMenu
            className="shrink-0 opacity-0 transition group-hover:opacity-100"
            trigger={
              <ButtonIcon
                variant="secondary"
                icon={<FontAwesomeIcon icon="fa-light fa-ellipsis" />}
              />
            }
          >
            <DropdownMenuItem
              title={t("common:edit")}
              leftIcon={<FontAwesomeIcon icon="fa-light fa-pen-to-square" />}
              onClick={onEdit}
            />
            <DropdownMenuItem
              variant="menuDanger"
              title={t("common:remove")}
              leftIcon={<FontAwesomeIcon icon="fa-light fa-trash" />}
              onClick={onRemove}
            />
          </DropdownMenu>
        }
      />
    </Box>
  );
}
